<template>
  <div class="basic-card-give">
    <common-table
      url="/api/supuCard/getGiveRecordByPage"
      :column="column"
      :searchButtons="buttons"
      ref="table"
      :searchForm="searchForm"
    ></common-table>
    <submit-form
      :title="formTitle"
      :visible.sync="formVisible"
      :formData="formData"
      :items="items"
      :rules="rules"
      :action="action"
      addUrl="/api/supuCard/insertGiveRecord"
      :onSubmitCallback="onSubmitCallback"
      :handleClose="handleClose"
    ></submit-form>
  </div>
</template>

<script>
  import global from '../../global/global'
  import supuService from '../../service/supuService'
    export default {
        name: "basic-card-give",
      data(){
        return{
          buttons:[{
            key:"add",
            name:"手动发卡",
            handleClick:this.onCreate
          }],
          column:[{
            prop:"memberName",
            label:"用户名",
            showTooltip:true
          },{
            prop:"cardTitle",
            label:"会员卡名称",
            showTooltip:true,
            formatter:this.cardTitleFormatter
          },{
            prop:"cardClassify",
            label:"类型",
            formatter:this.cardClassifyFormatter
          },{
            prop:"price",
            label:"价格",
            formatter:this.cardPriceFormatter
          },{
            prop:"validTime",
            label:"可用时长",
            formatter:this.validTimeFormatter,
          },{
            prop:"cardCode",
            label:"会员卡编号",
            showTooltip:true
          },{
            prop:"actualPrice",
            label:"实付金额"
          },{
            prop:"performanceDeptId",
            label:"归属门店",
            showTooltip:true,
            formatter:this.performanceDeptFormatter
          },{
            prop:"validDeptIds",
            label:"适用门店",
            showTooltip:true,
            formatter:this.validDeptFormatter
          },{
            prop:"isWork",
            label:"发放状态",
            formatter:this.isWorkFormatter
          },{
            prop:"getTime",
            label:"领取时间",
            dateFormatter:true,
            showTooltip:true
          },{
            prop:"useTime",
            label:"使用时间",
            dateFormatter:true,
            showTooltip:true
          }],
          searchForm:{
            cardType:"1"
          },
          formTitle:"",
          formVisible:false,
          formData:{
            cardType:"1",
            deptId:this.getCookie("deptId"),
            cardId:null,
            price:null,
            actualPrice:null,
            memberId:null,
            memberName:"",
            performanceDeptId:null
          },
          items:[{
            key:"cardId",
            name:"cardId",
            label:"选择会员卡",
            type:"select",
            prop:"cardId",
            options:[],
            onChange:this.cardSelectChange
          },{
            key:"price",
            name:"price",
            label:"售价",
            type:"number",
            precision:2,
            step:0.1,
            min:0,
            disabled:true
          },{
            key:"actualPrice",
            name:"actualPrice",
            label:"实收金额",
            type:"number",
            precision:2,
            step:0.1,
            min:0,
            prop:"actualPrice"
          },{
            key:"memberId",
            name:"memberId",
            label:"选择会员",
            type:"select",
            prop:"memberId",
            options:[],
            onChange:this.memberSelectChange
          },{
            key:"performanceDeptId",
            name:"performanceDeptId",
            label:"业绩归属门店",
            type:"select",
            prop:"performanceDeptId",
            options:[]
          }],
          rules:{
            cardId:[{required: true, message: '请选择会员卡', trigger: 'change'}],
            memberId:[{required: true, message: '请选择会员', trigger: 'change'}],
            actualPrice:[{required: true, message: '请填写实收金额', trigger: 'blur'}],
            performanceDeptId:[{required: true, message: '请选择会员', trigger: 'change'}],
          },
          action:"",
          cardList:[],
          memberList:[],
          storeList:[],
          cardClassifyList:[]
        }
      },
      created(){
        this.getCardList()
        this.getMemberList()
        this.getStoreList()
        this.getCardClassifyList()
      },
      methods:{
        onCreate(){
          this.formTitle = "手动发卡";
          this.formVisible = true;
          this.action = "add";
        },
        onSubmitCallback(){
          this.$refs['table'].getData();
        },
        handleClose(){
          this.formData = {
            cardType:"1",
            deptId:this.getCookie("deptId"),
            cardId:null,
            price:null,
            actualPrice:null,
            memberId:null,
            memberName:"",
            performanceDeptId:null
          }
        },
        validTimeFormatter(row, column, cellValue, index){
          return this.cardValueText(row.cardId,"validTime")+
            global.timeUnitText(this.cardValueText(row.cardId,"timeUnit"));
        },
        isWorkFormatter(row, column, cellValue, index){
          return cellValue === "1" ? "已发放":"已撤销"
        },
        cardTitleFormatter(row, column, cellValue, index){
          return this.cardValueText(row.cardId,"cardTitle")
        },
        cardClassifyFormatter(row, column, cellValue, index){
          const cardClassifyId = this.cardValueText(row.cardId,"cardClassify");
          const cardClassify = this.cardClassifyList.filter(item => item.id === cardClassifyId);
          if(cardClassify.length > 0){
            return cardClassify[0].name;
          }else{
            return "";
          }
        },
        cardPriceFormatter(row, column, cellValue, index){
          return this.cardValueText(row.cardId,"price")
        },
        cardValueText(cardId,str){
          const card = this.cardList.filter(item => item.id === cardId);
          if(card.length > 0){
            return card[0][str];
          }else{
            return "";
          }
        },
        performanceDeptFormatter(row, column, cellValue, index){
          return this.storeValueText(cellValue,"deptName");
        },
        validDeptFormatter(row, column, cellValue, index){
          return this.storeValueText(parseInt(this.cardValueText(row.cardId,"validDeptIds")),"deptName");
        },
        storeValueText(storeId,str){
          const store = this.storeList.filter(item => item.id === storeId);
          if(store.length > 0){
            return store[0][str];
          }else{
            return "";
          }
        },
        getCardList(){
          supuService.getCardList({
            cardType:"1"
          },(list) => {
            this.cardList = list;
            let options = [];
            list.forEach(item => {
              options.push({
                value:item.id,
                label:item.cardTitle
              })
            })
            this.items.forEach( item => {
              if(item.key == "cardId"){
                item.options = options;
              }
            })
          })
        },
        cardSelectChange(val){
          const card = this.cardList.filter(item => item.id === val)[0];
          this.formData.price = card.price;
        },
        memberSelectChange(val){
          const member = this.memberList.filter(item => item.id === val)[0];
          this.formData.memberName = member.name;
        },
        getMemberList(){
          supuService.getMemberList({},(list)=>{
            this.memberList = list;
            let options = [];
            list.forEach(item => {
              options.push({
                value:item.id,
                label:item.name
              })
            })
            this.items.forEach( item => {
              if(item.key == "memberId"){
                item.options = options;
              }
            })
          })
        },
        getStoreList(){
          supuService.getStoreList(list => {
            this.storeList = list;
            let options = [];
            list.forEach(item => {
              options.push({
                value:item.id,
                label:item.deptName
              })
            })
            this.items.forEach( item => {
              if(item.key == "performanceDeptId"){
                item.options = options;
              }
            })
          })
        },
        getCardClassifyList(){
          supuService.getSupuLabel("1","basicCard",(list) => {
            this.cardClassifyList = list;
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/supu/basicCardGive.vue